export default __webpack_public_path__ + "static/media/Simdustry black logo.765fc632.png";